module.exports = __webpack_public_path__ + "static/media/Russia.c7930220.png";